export default {
    UNDER_REVIEW: 100,
    APPROVED: 200,
    REJECTED: 300,
    PUBLISHED: 400,
    SUSPENDED: 500,
    UPDATED: 600
}